import { useEffect, useCallback, useState } from 'react';
import { Container, Message } from 'semantic-ui-react';
import Slider from 'react-slick';
import teaserHeroTopTemplate from '@kitconcept/volto-carousel-block/icons/teaser-template.svg';
import { defineMessages, useIntl } from 'react-intl';
import Icon from '@plone/volto/components/theme/Icon/Icon';

import cx from 'classnames';

import Body from './Body';
import rightArrowSVG from '@plone/volto/icons/right-key.svg';
import leftArrowSVG from '@plone/volto/icons/left-key.svg';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const PrevArrow = ({ className, style, onClick }) => (
  <button
    icon
    className={className}
    style={{ ...style, display: 'block' }}
    onClick={onClick}
    aria-label="left arrow"
  >
    <Icon name={leftArrowSVG} size="48px" />
  </button>
);

const NextArrow = ({ className, style, onClick }) => (
  <button
    icon
    className={className}
    style={{ ...style, display: 'block' }}
    onClick={onClick}
    aria-label="right arrow"
  >
    <Icon name={rightArrowSVG} size="48px" />
  </button>
);

const CarouselView = (props) => {
  const { block, data, isEditMode, openObjectBrowser, onChangeBlock } = props;

  const {
    aspectRatioDesktop = '1.7778',
    aspectRatioMobile = '1.5',
    items_to_show,
    autoplay,
    autoplaySpeed,
    columns,
    headline,
    infinite,
    useLargeContainer,
  } = data;

  const [mobileSize, setmobileSize] = useState(false);
  const intl = useIntl();
  let noOfSlide = items_to_show ?? 2;
  if (items_to_show) {
    if (items_to_show <= 0) {
      noOfSlide = 1;
    } else if (items_to_show > 5) {
      noOfSlide = 5;
    } else {
      noOfSlide = items_to_show;
    }
  }

  if (__CLIENT__ && (window.innerWidth < 520 || mobileSize)) {
    noOfSlide = 1;
  }

  const updateNoOfSlide = useCallback(() => {
    if (window.innerWidth < 520) {
      setmobileSize(true);
    } else {
      setmobileSize(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', updateNoOfSlide);
    return () => window.removeEventListener('resize', updateNoOfSlide);
  }, [updateNoOfSlide]);

  useEffect(() => {
    updateNoOfSlide();
  }, [updateNoOfSlide]);

  return (
    <Container>
      <div
        className={cx('block carousel carousel-block', {
          'wrapperstyle full': useLargeContainer,
        })}
        style={{
          '--carousel-user-aspect-ratio-mobile': aspectRatioMobile,
          '--carousel-user-aspect-ratio-desktop': aspectRatioDesktop,
        }}
      >
        {(columns?.length === 0 || !columns) && isEditMode && (
          <Message>
            <div className="teaser-item default">
              <img src={teaserHeroTopTemplate} alt="" />
              <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
            </div>
          </Message>
        )}
        {columns?.length > 0 && (
          <div
            className={cx({ 'full-width': useLargeContainer })}
            style={{ backgroundColor: props.bg_color }}
          >
            {headline && <h2 className="headline">{headline}</h2>}
            <Slider
              dots
              infinite={infinite}
              speed={500}
              slidesToShow={+noOfSlide}
              slidesToScroll={+noOfSlide}
              nextArrow={<NextArrow />}
              prevArrow={<PrevArrow />}
              autoplay={autoplay}
              autoplaySpeed={
                parseInt(autoplaySpeed) ? parseInt(autoplaySpeed) * 1000 : null
              }
              pauseOnHover={true}
              pauseOnFocus={true}
              pauseOnDotsHover={true}
            >
              {columns &&
                columns.map((item, index) => (
                  <Body
                    key={item['@id']}
                    data={item}
                    isEditMode={isEditMode}
                    dataBlock={data}
                    index={index}
                    block={block}
                    openObjectBrowser={openObjectBrowser}
                    onChangeBlock={onChangeBlock}
                  />
                ))}
            </Slider>
          </div>
        )}
      </div>
    </Container>
  );
};

export default CarouselView;
